module.exports = __webpack_public_path__ + "img/l1.40325b98.png";